import { message, notification } from "antd";
import _ from "lodash";
import qs from "qs";
import moment from "moment";

/**
 * 根据树子节点ID查找所有父节点ID
 * @param {array} dataSource 树形结构数据源
 * @param {number} nodeId 子节点ID
 * @returns {array} 包含所有父节点ID的数组，按照从根节点到直接父节点的顺序排序
 */
export const findParentIds = (dataSource, nodeId) => {
  const parentIds = []; // 用于存储所有父节点ID的数组

  // 定义一个递归函数，用于遍历整棵树并查找子节点的所有父节点
  function traverse(node, nodeId) {
    if (node.id === nodeId) {
      // 如果当前节点的ID等于子节点的ID，则表示已经找到了子节点，可以开始向上查找父节点
      return true; // 返回true表示已经找到了子节点
    }

    if (node.children) {
      // 如果当前节点有子节点，则继续遍历子节点
      for (const childNode of node.children) {
        if (traverse(childNode, nodeId)) {
          // 如果在子节点中找到了子节点的父节点，则将当前节点的ID添加到父节点ID数组中，并返回true表示已经找到了子节点
          parentIds.push(node.id);
          return true;
        }
      }
    }

    return false; // 如果当前节点不是子节点的父节点，则返回false
  }

  // 从根节点开始遍历整棵树，并调用递归函数查找子节点的所有父节点
  for (const node of dataSource) {
    if (traverse(node, nodeId)) {
      // 如果在当前节点的子树中找到了子节点的父节点，则直接退出循环
      break;
    }
  }

  return [...parentIds.reverse(), nodeId]; // 返回所有父节点ID的数组
};

//商品属性组合算法 笛卡尔积算法
export const calcDescartes = () => {
  return Array.prototype.reduce.call(
    arguments,
    function (a, b) {
      let ret = [];
      a.forEach(function (a_item) {
        b.forEach(function (b_item) {
          ret.push(a_item.concat([b_item]));
        });
      });
      return ret;
    },
    [[]]
  );
};

/**
 * 文件夹大小换算
 * @param {Number} size
 * @returns {Number}
 */
export const getfilesize = (size) => {
  if (!size) return "0B";

  var num = 1024.0; //byte

  if (size < num) return size.toFixed(2) + "B";
  if (size < Math.pow(num, 2)) return (size / num).toFixed(2) + "KB"; //kb
  if (size < Math.pow(num, 3))
    return (size / Math.pow(num, 2)).toFixed(2) + "MB"; //M
  if (size < Math.pow(num, 4))
    return (size / Math.pow(num, 3)).toFixed(2) + "GB"; //G
  return (size / Math.pow(num, 4)).toFixed(2) + "TB"; //T
};

/**
 * 将数字根据大小进行分片
 * @param {Number} params 被分片的数字
 * @param {Number} fixedSize 分片大小
 * @returns <Array>
 */
export const fixedSize = (params = 700, fixedSize = 100) => {
  params = Number(params);
  fixedSize = Number(fixedSize);
  if (!params || !fixedSize) return "数据有误";

  let arrayObjec = [],
    start = 0;
  if (params <= fixedSize) {
    arrayObjec.push({ start: 0, end: params, isUploaded: false });
  } else {
    for (let i = 0; i < params; i++) {
      if (i - start == fixedSize)
        arrayObjec.push({ start: start, end: i, isUploaded: false }),
          (start = i);
    }

    let len = arrayObjec.length;
    if (arrayObjec[len - 1].end < params)
      arrayObjec.push({
        start: arrayObjec[len - 1].end,
        end: params,
        isUploaded: false,
      });
  }

  return arrayObjec;
};

/**
 * 文件Blob切割
 * @param {Bolb} blob 文件blob
 * @param {Number} startByte 开始字节
 * @param {Number} endByte 结束字节
 * @returns Blob
 */
export const blobSlice = (blob, startByte, endByte) => {
  if (blob.slice) {
    return blob.slice(startByte, endByte);
  }
  // 兼容firefox
  if (blob.mozSlice) {
    return blob.mozSlice(startByte, endByte);
  }
  // 兼容webkit
  if (blob.webkitSlice) {
    return blob.webkitSlice(startByte, endByte);
  }
  return null;
};

/**
 * 将数字根据次数进行分片
 * @param {Number} params 被分片的数字
 * @param {Number} fixedTimes 分片次数
 * @returns <Array>
 */
export const fixedTimes = (params = 700, fixedTimes = 7) => {
  params = Number(params);
  fixedTimes = Number(fixedTimes);
  if (!params || !fixedTimes) throw new Error("数据有误");

  let arrayObjec = [],
    val = Math.round(params / fixedTimes),
    start = 0;

  for (let i = 0; i < fixedTimes; i++)
    arrayObjec.push({ start: start, end: start + val }),
      (start = start + val + 1);
  arrayObjec[arrayObjec.length - 1].end = params;

  return arrayObjec;
};

/**
 * 多维数组扁平化
 * @param {Array<T>} deepArr 多维数组
 * @param {Array<string>} hideKeys 扁平后不要的key值
 * @returns Array<T>
 */
export const toFlatness = (deepArr = [], hideKeys = []) => {
  const reg = new RegExp(hideKeys.join("|"));
  const list = [];
  function format(arr = deepArr) {
    arr.forEach((item) => {
      const currentItem = { ...item }; // 如果有数据代理 可以用深拷贝代替
      if (hideKeys && hideKeys.length) {
        Object.keys(item).forEach((k) => {
          if (reg.test(k)) {
            delete currentItem[k];
          }
        });
      }
      list.push(currentItem);
      if (item.children) {
        format(item.children);
      }
    });
    return list;
  }
  format();
  return list;
};
/**
 * 导航组件用线转树
 * @param {Array<T>} list 线的数组
 * @param {Array<string>} key 子级匹配键名
 * @param {Array<string>} extendKey 父级匹配键名
 */
export const array2treeMenu = (list, key, extendKey) => {
  var map = {};
  list.forEach((item) => {
    if (!map[item[key]]) {
      item.label = item.name;
      item.value = item.id;
      map[item[key]] = item;
    }
  });
  list.forEach((item) => {
    if (!!item[extendKey]) {
      map[item[extendKey]].children
        ? map[item[extendKey]].children.push(item)
        : (map[item[extendKey]].children = [item]);
    }
  });
  return list.filter(function (item) {
    if (!item[extendKey]) {
      return item;
    }
  });
};

/**
 * 线转树
 * @param {Array<T>} list 线的数组
 * @param {Array<string>} key 子级匹配键名
 * @param {Array<string>} extendKey 父级匹配键名
 */
export const array2tree = (list, key, extendKey) => {
  var map = {};
  list.forEach((item) => {
    if (!map[item[key]]) {
      map[item[key]] = item;
    }
  });
  list.forEach((item) => {
    if (!!item[extendKey]) {
      map[item[extendKey]].children
        ? map[item[extendKey]].children.push(item)
        : (map[item[extendKey]].children = [item]);
    }
  });
  return list.filter(function (item) {
    if (!item[extendKey]) {
      return item;
    }
  });
};

/**
 * 树转线
 * @param {Array<T>} source 树
 * @param {Array<string>} childKey 子项键名
 * @returns Array<T>
 */
export const tree2line = (source, childKey = "children") => {
  let res = [];
  source.forEach((el) => {
    res.push(el);
    el[childKey] && el[childKey].length > 0 ? tree2line(el[childKey]) : ""; // 子级递归
  });
  return res;
};

/**
 * 检测文件后缀并返回图标icon名称
 * @param {String} name 多维数组
 * @returns String
 */
export const searchIconExt = (name) => {
  let getExt = name.split(".")[name.split(".").length - 1].toLowerCase();
  const exts = {
    "icon-wenjianleixing-ppt": ["ppt"],
    "icon-wenjianleixing-psd": ["psd"],
    // "icon-wenjianleixing-gif": ["gif"],
    "icon-wenjianleixing-excel": ["xls", "xlsx", "csv"],
    "icon-wenjianleixing-sql": ["sql", "db", "mdf", "mdb"],
    "icon-wenjianleixing-shipin": [
      "mp4",
      "mkv",
      "avi",
      "mov",
      "mpg",
      "mpeg",
      "wmv",
    ],
    "icon-wenjianleixing-wendang": ["doc", "docx"],
    "icon-wenjianleixing-pdf": ["pdf"],
    "icon-wenjianleixing-exe": ["exe"],
    "icon-wenjianleixing-eps": ["eps"],
    "icon-wenjianleixing-yasuobao": ["zip", "rar", "7z", "jar"],
    "icon-wenjianleixing-yinpin": ["mp3"],
    img: ["jpg", "jpeg", "png", "svg", "bmp", "eps", "raw", "gif"],
    "icon-wenjianleixing-tupian": ["heic", "webp"],
    "icon-wenjianleixing-biaozhuntu-jishiben": ["txt"],
  };
  let res = "icon-wenjianleixing-biaozhuntu-weizhiwenjian";
  for (let key in exts) {
    if (exts[key].indexOf(getExt) >= 0) {
      res = key;
    }
  }

  return res;
};

/**
 * 获取文件类型
 */
export const getFileType = (reader) => {
  const bufferInt = new Uint8Array(reader.result);
  const arr = bufferInt.slice(0, 4); // 通用格式图片
  const headerArr = bufferInt.slice(0, 16); // heic格式图片
  let header = "";
  let allHeader = "";
  let realMimeType;

  for (let i = 0; i < arr.length; i++) {
    header += arr[i].toString(16); // 转成16进制的buffer
  }

  for (let i = 0; i < headerArr.length; i++) {
    allHeader += headerArr[i].toString(16);
  }
  // magic numbers: http://www.garykessler.net/library/file_sigs.html
  switch (header) {
    case "89504e47":
      realMimeType = "image/png";
      break;
    case "47494638":
      realMimeType = "image/gif";
      break;
    case "ffd8ffDB":
    case "ffd8ffe0":
    case "ffd8ffe1":
    case "ffd8ffe2":
    case "ffd8ffe3":
    case "ffd8ffe8":
      realMimeType = "image/jpeg";
      break;
    case "00020": // heic开头前4位可能是00020也可能是00018，其实这里应该是判断头尾000的，可以自己改下
    case "00018":
      allHeader.lastIndexOf("68656963") === 13 ||
      allHeader.lastIndexOf("68656966") === 13
        ? (realMimeType = "image/heic")
        : (realMimeType = "unknown");
      break;
    default:
      realMimeType = "unknown";
      break;
  }
  return realMimeType;
};

/**
 * 根据文件后缀获取视频文件对应ContentType
 * @param {String} extName 视频文件后缀名 不包含. 如 mkv
 */
export const getVideoContentType = (extName) => {
  switch (extName) {
    case "wmv":
      return "video/x-ms-wmv";
      break;
    case "mp4":
      return "video/mp4";
      break;
    case "avi":
      return "video/avi";
      break;
    case "wma":
      return "video/wma";
      break;
    case "w4a":
      return "video/mp4";
      break;
    case "w4v":
      return "video/mp4";
      break;
    case "wov":
      return "video/quicktime";
      break;
    case "3gp":
      return "video/3gpp";
      break;
    case "mp3":
      return "audio/mp3";
      break;
    case "webm":
      return "video/webm";
      break;
    case "flv":
      return "video/x-flv";
      break;
    case "mpeg":
      return "video/mpg";
      break;
    case "mts":
      return "video/vnd.dlna.mpeg-tts";
      break;
    case "vob":
      return "video/vob";
      break;
    case "mkv":
      return "video/mp4";
      break;
    default:
      return "video/mp4";
      break;
  }
};

/**
 * 打开右侧消息
 * @param {String} type 消息类型 success info warning error
 * @param {String} title 消息标题
 * @param {String} intro 消息内容
 */
export const openNotificationWithIcon = (type, title, intro) => {
  notification[type]({
    message: title,
    description: intro,
  });
};

/**
 * 为指定对象数组插入子集
 * @param {Array} arr 将要插入子集的数组
 * @param {Array} childs 被插入的子集数组
 * @param {String} key 标识对应插入对象key名 如：key
 * @param {String} code 标识对应插入对象key值 如：storage
 * @param {String} childKey 子集将要插入的key名
 * @returns arr 组合后的数组
 */
export const insertChild = (arr, childs, key, code, childKey) => {
  Object.keys(arr).map((item) => {
    if (arr[item][key] == code) {
      arr[item][childKey] = [...arr[item][childKey], ...childs];
    }
  });

  return arr;
};

/**
 * 计算 RAID 容量单位
 * @param {Number} val raid size 单位为GB
 * @param {Number} total 总raid size 单位为GB
 * @returns
 */
export const raidSizeUnit = (val, total) => {
  return 0 == total
    ? ""
    : 1e3 <= val
    ? (Math.round(val / 100) / 10).toFixed(2) + " TB"
    : val.toFixed(2) + " GB";
};

/**
 * 计算 RAID 占用百分比
 * @param {Number} val raid size 单位为GB
 * @param {Number} total 总raid size 单位为GB
 * @returns
 */
export const raidSizeStyle = (val, total) => {
  return 0 == total ? 0 : ((100 * val) / total).toFixed(2);
};

/**
 * 错误/无法展示图片占位
 */
export const errorImg =
  "data:image/png;base64,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";
